<template>
    <div>
        <Button 
            type="button" 
            icon="pi pi-ellipsis-v" 
            @click="toggle" 
            aria-haspopup="true"
            aria-controls="overlay_menu" 
            class="p-button-text p-button-rounded p-button-secondary" 
        />
        <Menu 
            ref="menu" 
            id="overlay_menu" 
            :model="items" 
            :popup="true" 
        />
    </div>
</template>

<script>
import { ref, defineComponent, computed } from 'vue'
export default defineComponent({
    name: 'DropdownMenu',
    props: {
        item: Object,
        deleteItem: Function,
        editItem: Function
    },
    setup(props) {
        const menu = ref(null)
        const toggle = (event) => {
            if (menu.value) {
                menu.value.toggle(event)
            }
        }
        const items = computed(() => [
            {
                label: 'Opciones',
                items: [
                    {
                        label: 'Editar',
                        icon: 'pi pi-pencil',
                        command: () => {
                            if (props.editItem) {
                                props.editItem(props.item)
                            }
                            menu.value?.toggle()
                        }
                    },
                    {
                        label: 'Eliminar',
                        icon: 'pi pi-trash',
                        command: (event) => {
                            if (props.item?.arrId) {
                                props.deleteItem?.(event.originalEvent, props.item.arrId)
                            } else {
                                props.deleteItem?.(event.originalEvent)
                            }
                            menu.value?.toggle()
                        }
                    }
                ]
            }
        ])
        return {
            menu,
            toggle,
            items
        }
    }
})
</script>